export type VehicleSample = { time: number; coord: [number, number] };

/** Work out when animation is actually needed, including delayed GPS samples. */
export function sampleVehicleHistory(history: VehicleSample[], displayTime: number) {
  let position = history[0].coord;
  let animating = false;
  let wakeInMs = Infinity;
  if (history.length > 1) {
    if (displayTime < history[0].time) {
      wakeInMs = history[0].time - displayTime;
    } else {
      position = history[history.length - 1].coord;
      for (let i = 0; i < history.length - 1; i++) {
        const start = history[i];
        const end = history[i + 1];
        if (displayTime < start.time || displayTime >= end.time) continue;
        const t = (displayTime - start.time) / (end.time - start.time);
        position = [
          start.coord[0] + (end.coord[0] - start.coord[0]) * t,
          start.coord[1] + (end.coord[1] - start.coord[1]) * t,
        ];
        animating = true;
        break;
      }
    }
  }
  return { position, animating, wakeInMs };
}
